/** Recuperado del despliegue 2026-10-05. Conserva lógica y memoización originales. */
import {
  rec_AC as AC,
  rec_Ar as Ar,
  rec_BusquedaGlobal as BusquedaGlobal,
  rec_CC as CC,
  rec_CambiosPendientes as CambiosPendientes,
  rec_Cn as Cn,
  rec_Componente_xC_120_67 as Componente_xC_120_67,
  rec_DC as DC,
  rec_EC as EC,
  rec_JSXRuntime as JSXRuntime,
  rec_Li as Li,
  rec_MC as MC,
  rec_MenuCrear as MenuCrear,
  rec_NC as NC,
  rec_OC as OC,
  rec_PanelNotificaciones as PanelNotificaciones,
  rec_React as React,
  rec_SC as SC,
  rec_Si as Si,
  rec_TC as TC,
  rec_TransicionMarca as TransicionMarca,
  rec_Ui as Ui,
  rec_api as api,
  rec_borrarSesion as borrarSesion,
  rec_bs as bs,
  rec_co as co,
  rec_esAdministrador as esAdministrador,
  rec_fi as fi,
  rec_hx as hx,
  rec_jC as jC,
  rec_obtenerUsuario as obtenerUsuario,
  rec_puedeIncidencias as puedeIncidencias,
  rec_puedeInspecciones as puedeInspecciones,
  rec_puedeMovilidad as puedeMovilidad,
  rec_puedePagina as puedePagina,
  rec_puedeRutaAdmin as puedeRutaAdmin,
  rec_puedePlanner as puedePlanner,
  rec_refrescarPermisos as refrescarPermisos,
  rec_px as px,
  rec_ra as ra,
  rec_rt as rt,
  rec_si as si,
  rec_so as so,
  rec_st as st,
  rec_vi as vi,
  rec_wC as wC,
  rec_xi as xi,
  rec_xs as xs,
} from "../../runtime/index.jsx";
import { viendoComo, volverDeVerComo } from "../administracion/verComo.js";
import { iniciarAppInstalada } from "../pwa/insignia.js";
export function EstructuraPrincipal({
  title: e,
  children: t,
  accionesRapidas: n = !0,
}) {
  let r = st(),
    i = obtenerUsuario(),
    [a, o] = (0, React.useState)(!1),
    [s, c] = (0, React.useState)(() => {
      try {
        return localStorage.getItem(jC) === `1`;
      } catch {
        return !1;
      }
    });
  function l() {
    c((e) => {
      try {
        localStorage.setItem(jC, e ? `0` : `1`);
      } catch {}
      return !e;
    });
  }
  // Permisos vivos: al abrir, al volver a la pestaña y cuando cambian, se
  // repinta el menú (sin esperar a que venza la sesión).
  let [, repintar] = (0, React.useState)(0);
  (0, React.useEffect)(() => {
    let alCambiar = () => repintar((x) => x + 1),
      alVolver = () => document.visibilityState === `visible` && refrescarPermisos();
    window.addEventListener(`gth-permisos`, alCambiar);
    document.addEventListener(`visibilitychange`, alVolver);
    refrescarPermisos();
    iniciarAppInstalada();
    return () => {
      window.removeEventListener(`gth-permisos`, alCambiar);
      document.removeEventListener(`visibilitychange`, alVolver);
    };
  }, []);
  let [u, f] = (0, React.useState)(px()),
    { pathname: p } = rt(),
    [m, h] = (0, React.useState)(() => p.startsWith(`/admin`)),
    [g, _] = (0, React.useState)(null),
    [v, y] = (0, React.useState)(0);
  (0, React.useEffect)(() => {
    let e = !0,
      t = () =>
        api(`/tareas/pendientes?tamano=100`)
          .then((t) => {
            e &&
              y(
                (t?.conformes?.items ?? []).filter((e) => e.conformidadDemorada)
                  .length,
              );
          })
          .catch(() => {});
    t();
    let n = setInterval(t, 3e5);
    return () => {
      ((e = !1), clearInterval(n));
    };
  }, []);
  let [b, x] = (0, React.useState)(0),
    [S, C] = (0, React.useState)(!1),
    w = puedeIncidencias() || puedeInspecciones();
  (0, React.useEffect)(() => {
    if (!w) return;
    let e = !0,
      t = () =>
        api(`/pendientes/resumen`)
          .then((t) => {
            e && (x(Number(t?.vencidas) || 0), C(t?.levanta === !0));
          })
          .catch(() => {});
    t();
    let n = setInterval(t, 3e5);
    return () => {
      ((e = !1), clearInterval(n));
    };
  }, [w]);
  let T = w && S,
    [E, D] = (0, React.useState)(!1);
  (0, React.useEffect)(() => {
    let e = !0;
    return (
      AC().then((t) => {
        e && D(t);
      }),
      () => {
        e = !1;
      }
    );
  }, []);
  let O = [];
  if ((puedePlanner() && O.push(...CC.filter((e) => puedePagina(e.to))), T)) {
    let e = O.findIndex((e) => e.to === `/aprobaciones`);
    O.splice(e < 0 ? O.length : e + 1, 0, DC);
  }
  (E && O.push(OC),
    (0, React.useEffect)(() => {
      let e = () => {
        co();
        let { pathname: e, search: t, hash: n } = window.location,
          r = e === `/` ? `` : `&volver=${encodeURIComponent(`${e}${t}${n}`)}`;
        _({
          mensaje: `Tu sesión expiró`,
          destino: `/login?expirada=1${r}`,
        });
      };
      return (
        window.addEventListener(`sesion-expirada`, e),
        so(),
        () => window.removeEventListener(`sesion-expirada`, e)
      );
    }, [r]));
  function k() {
    _({
      mensaje: `Hasta luego`,
      destino: `/login`,
    });
  }
  function A(e) {
    (borrarSesion(),
      r(e, {
        replace: !0,
      }));
  }
  return (
    <div
      className={`flex h-screen overflow-hidden`}
      children={[
        a && (
          <div
            className={`fixed inset-0 z-30 bg-black/40 lg:hidden`}
            onClick={() => o(!1)}
            aria-hidden={`true`}
          />
        ),
        <aside
          className={`fixed inset-y-0 left-0 z-40 flex w-60 shrink-0 flex-col bg-(--sidebar-bg) transition-transform duration-300 lg:static lg:translate-x-0 ${a ? `translate-x-0` : `-translate-x-full`} ${s ? `lg:hidden` : ``}`}
          children={[
            <div
              className={`relative flex h-14 shrink-0 items-center justify-center border-b border-(--sidebar-borde) px-4`}
              children={[
                <img
                  src={xs(`SIDEBAR`, xs(`PRINCIPAL`, SC))}
                  alt={bs()}
                  className={`h-8 w-auto brightness-0 invert`}
                />,
                <button
                  type={`button`}
                  onClick={() => o(!1)}
                  aria-label={`Cerrar menu`}
                  className={`absolute right-3 rounded-lg p-1.5 text-(--sidebar-fg-tenue) transition hover:bg-(--sidebar-hover) hover:text-(--sidebar-fg) lg:hidden`}
                  children={(0, JSXRuntime.jsx)(ra, {
                    className: `h-5 w-5`,
                  })}
                />,
              ]}
            />,
            <nav
              className={`scroll-sidebar min-h-0 flex-1 space-y-1 overflow-y-auto p-3`}
              children={[
                O.map((e) => (
                  <Cn
                    key={e.to}
                    to={e.to}
                    end={e.end}
                    className={NC}
                    onClick={() => o(!1)}
                    children={[
                      <e.icon className={`h-4 w-4`} />,
                      e.label,
                      e.to === `/observaciones` && b > 0 && (
                        <span
                          title={`${b} pasaron su fecha`}
                          className={`ml-auto flex h-5 min-w-5 items-center justify-center rounded-full bg-(--error) px-1.5 text-[11px] font-semibold text-white`}
                          children={b}
                        />
                      ),
                      e.to === `/aprobaciones` && v > 0 && (
                        <span
                          title={`${v} esperando hace más de ${MC} días`}
                          className={`ml-auto flex h-5 min-w-5 items-center justify-center rounded-full bg-(--error) px-1.5 text-[11px] font-semibold text-white`}
                          children={v}
                        />
                      ),
                    ]}
                  />
                )),
                puedeMovilidad() && (
                  <Cn
                    to={TC.to}
                    className={NC}
                    onClick={() => o(!1)}
                    children={[<TC.icon className={`h-4 w-4`} />, TC.label]}
                  />
                ),
                EC.filter((e) => e.visible()).map((e) => (
                  <Cn
                    key={e.to}
                    to={e.to}
                    className={NC}
                    onClick={() => o(!1)}
                    children={[
                      <e.icon className={`h-4 w-4`} />,
                      e.label,
                      e.alerta === `observaciones` && b > 0 && (
                        <span
                          title={`${b} pasaron su fecha de levantamiento`}
                          className={`ml-auto flex h-5 min-w-5 items-center justify-center rounded-full bg-(--error) px-1.5 text-[11px] font-semibold text-white`}
                          children={b}
                        />
                      ),
                    ]}
                  />
                )),
                wC.some((e) => puedeRutaAdmin(e.to)) && (
                  <div
                    className={`pt-1`}
                    children={[
                      <button
                        type={`button`}
                        onClick={() => h((e) => !e)}
                        aria-expanded={m}
                        className={`${NC({
                          isActive: !1,
                        })} w-full`}
                        children={[
                          <Li className={`h-4 w-4`} />,
                          `Configuración`,
                          <Ar
                            className={`ml-auto h-4 w-4 transition duration-200 ease-(--curva) ${m ? `rotate-180` : ``}`}
                          />,
                        ]}
                      />,
                      m && (
                        <div
                          className={`animar-cascada mt-1 space-y-1 border-l border-(--sidebar-borde) pl-3`}
                          children={wC.filter((e) => puedeRutaAdmin(e.to)).map((e) => (
                            <Cn
                              key={e.to}
                              to={e.to}
                              end={e.end}
                              className={NC}
                              onClick={() => o(!1)}
                              children={[
                                <e.icon className={`h-4 w-4`} />,
                                e.label,
                              ]}
                            />
                          ))}
                        />
                      ),
                    ]}
                  />
                ),
              ]}
            />,
            <div
              className={`border-t border-(--sidebar-borde) p-3`}
              children={
                <div
                  className={`flex items-center justify-between gap-2`}
                  children={[
                    <span
                      className={`truncate text-sm text-(--sidebar-fg)`}
                      children={i?.nombre ?? i?.usuario ?? `Usuario`}
                    />,
                    <div
                      className={`flex shrink-0 items-center gap-1`}
                      children={[
                        <button
                          type={`button`}
                          onClick={() => f(hx())}
                          aria-label={`Cambiar tema`}
                          title={`Cambiar tema`}
                          className={`rounded-lg p-1.5 text-(--sidebar-fg-tenue) transition hover:bg-(--sidebar-activo) hover:text-(--sidebar-fg)`}
                          children={
                            u === `dark` ? (
                              (0, JSXRuntime.jsx)(vi, {
                                className: `h-4 w-4`,
                              })
                            ) : (
                              <Ui className={`h-4 w-4`} />
                            )
                          }
                        />,
                        <button
                          type={`button`}
                          onClick={k}
                          aria-label={`Cerrar sesion`}
                          title={`Cerrar sesion`}
                          className={`rounded-lg p-1.5 text-(--sidebar-fg-tenue) transition hover:bg-(--sidebar-activo) hover:text-(--sidebar-fg)`}
                          children={(0, JSXRuntime.jsx)(si, {
                            className: `h-4 w-4`,
                          })}
                        />,
                      ]}
                    />,
                  ]}
                />
              }
            />,
          ]}
        />,
        <div
          className={`flex min-w-0 flex-1 flex-col`}
          children={[
            <header
              className={`flex h-14 shrink-0 items-center gap-3 border-b border-(--border) bg-(--bg) px-4 sm:px-6`}
              children={[
                <button
                  type={`button`}
                  onClick={() => o(!0)}
                  aria-label={`Abrir menu`}
                  className={`rounded-lg p-1.5 text-(--text) transition hover:bg-(--accent-bg) hover:text-(--text-h) lg:hidden`}
                  children={(0, JSXRuntime.jsx)(fi, {
                    className: `h-5 w-5`,
                  })}
                />,
                <button
                  type={`button`}
                  onClick={l}
                  aria-label={s ? `Mostrar el menú` : `Ocultar el menú`}
                  title={s ? `Mostrar el menú` : `Ocultar el menú`}
                  aria-pressed={s}
                  className={`hidden rounded-lg p-2 text-(--text) transition hover:bg-(--accent-bg) hover:text-(--text-h) lg:inline-flex`}
                  children={
                    s ? (
                      <Si className={`h-5 w-5`} />
                    ) : (
                      (0, JSXRuntime.jsx)(xi, {
                        className: `h-5 w-5`,
                      })
                    )
                  }
                />,
                <h1
                  className={`!m-0 hidden shrink-0 truncate text-lg font-medium text-(--text-h) sm:block`}
                  children={e}
                />,
                <div
                  className={`flex min-w-0 flex-1 items-center justify-end gap-3 sm:justify-center`}
                  children={<BusquedaGlobal />}
                />,
                <PanelNotificaciones />,
              ]}
            />,
            <main
              className={`min-h-0 flex-1 overflow-y-auto bg-(--bg) p-4 sm:p-6`}
              children={[
                viendoComo() && (
                  <div
                    role={`status`}
                    className={`mb-3 flex flex-wrap items-center justify-between gap-2 rounded-2xl border border-(--warning-border) bg-(--warning-bg) px-4 py-2 text-sm text-(--warning-texto)`}
                    children={[
                      <span children={[`👁 Estás viendo el sistema como `, <strong children={viendoComo().nombre} />, ` · sólo lectura`]} />,
                      <button type={`button`} onClick={volverDeVerComo}
                        className={`rounded-full border border-(--warning-border) px-3 py-1 text-xs font-medium hover:bg-(--bg)`}
                        children={`Volver a mi sesión`} />,
                    ]}
                  />
                ),
                <div
                  className={`mb-3 empty:mb-0`}
                  children={<CambiosPendientes />}
                />,
                t,
              ]}
            />,
            n && <MenuCrear />,
            <Componente_xC_120_67 />,
          ]}
        />,
        g && (
          <TransicionMarca
            modo={`cerrar`}
            mensaje={g.mensaje}
            onDone={() => A(g.destino)}
          />
        ),
      ]}
    />
  );
}
